module.exports = __webpack_public_path__ + "static/media/sensor8.7063323a.jpg";